/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { GridColumnJustify } from '@veeam-vspc/shared/components';

import type { GridColumnProps } from '@veeam-vspc/shared/components';
import type { CompanyQuotaUsage } from '@veeam-vspc/models/web-controllers';

import { TopsGrid } from '../../../TopsGrid';
import { useCommonSettings } from '../../../../hooks';
import { TopDataUrls } from '../../../../enums';
import { PercentColumnRender, SizeColumnRender } from '../../../columns';
import { ConfigSectionIds } from 'core/enums';


import type { TopsGridComponentWrapper } from '../../../../interfaces';

export const QuotaUsage: React.FC<TopsGridComponentWrapper> = ({ maxNumberOfRows }) => {
    const settings = useCommonSettings<CompanyQuotaUsage>({ maxNumberOfRows, getDataRequestUrl: TopDataUrls.QuotaUsage });
    const { lang } = settings;

    const columns: GridColumnProps<CompanyQuotaUsage>[] = [
        {
            id: 'companyName',
            title: lang.COMPANY,
            cell: rowData => rowData.companyName,
        },
        {
            id: 'siteName',
            title: lang.SITE,
            cell: rowData => rowData.siteName,
        },
        {
            id: 'quota',
            title: lang.QUOTA,
            cell: rowData => <SizeColumnRender value={rowData.quota} />,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },
        {
            id: 'freeSpace',
            title: lang.FREE_SPACE,
            cell: rowData => <SizeColumnRender value={rowData.freeSpace} />,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },
        {
            id: 'usedSpacePercent',
            title: lang.USAGE,
            cell: rowData => <PercentColumnRender value={rowData.usedSpacePercent} />,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },
        {
            id: 'usedSpace',
            title: lang.USED_SPACE,
            cell: rowData => <SizeColumnRender value={rowData.usedSpace} />,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },
    ];

    return (
        <TopsGrid
            title={lang.TOP_COMPANIES_BY_USED_SPACE}
            columns={columns}
            sectionId={ConfigSectionIds.TopsCompanies}
            maxNumberOfRows={maxNumberOfRows}
            {...settings}
        />
    );
};
